module.exports = __webpack_public_path__ + "static/media/favicon.1f0d8998.ico";